import { useState } from 'react';
import { useSelector } from 'react-redux';

import useUsersFetch from './hooks/useUsersFetch';
import { getUsers, getUsersIsFetching } from '@selectors/users';
import UsersTable from './UsersTable';
import CreateUserModal from './CreateUserModal';
import CreateHeader from '@components/layout/createHeader/CreateHeader';
import Title from 'lib/src/components/typography/Title';
import UpdateUserModal from './UpdateUserModal';
import UpdateUserPasswordModal from './UpdateUserPasswordModal';
import DeleteUserModal from './DeleteUserModal';
import Breadcrumb from '@components/breadcrumb/Breadcrumb';
import { usersBreadcrumb } from '../../../constants/breadcrumbItems';

const Users: React.FC = () => {
    useUsersFetch();
    const users = useSelector(getUsers);
    const isFetching = useSelector(getUsersIsFetching);

    const [showCreateModal, setShowCreateModal] = useState(false);
    const [userToEdit, setUserToEdit] = useState<number | null>(null);
    const [userToEditPassword, setUserToEditPassword] = useState<number | null>(null);
    const [userToDelete, setUserToDelete] = useState<number | null>(null);

    return (
        <>
            <Breadcrumb items={usersBreadcrumb} />
            <CreateHeader>
                <Title>Users</Title>
            </CreateHeader>

            <UsersTable
                users={users}
                isFetching={isFetching}
                setUserToEdit={setUserToEdit}
                setUserToEditPassword={setUserToEditPassword}
                setUserToDelete={setUserToDelete}
            />
            {showCreateModal && <CreateUserModal closeModal={() => setShowCreateModal(false)} />}
            {!!userToEdit && (
                <UpdateUserModal user={users[userToEdit]} closeModal={() => setUserToEdit(null)} />
            )}
            {!!userToEditPassword && (
                <UpdateUserPasswordModal
                    user={users[userToEditPassword]}
                    closeModal={() => setUserToEditPassword(null)}
                />
            )}
            {!!userToDelete && (
                <DeleteUserModal
                    user={users[userToDelete]}
                    closeModal={() => setUserToDelete(null)}
                />
            )}
        </>
    );
};

export default Users;
